<template>
  <teleport v-if="widget" to="#crentStationList">
    <div class="orm-container orm-pt-56 orm-pb-32">
      <div class="orm-row center-xs">
        <div class="orm-col-xs-12">
          <div class="orm-row" v-if="stations">
            <div
              v-for="station in stations"
              :key="station.id"
              class="orm-col-xs-12 orm-col-lg-6 orm-mb-48"
            >
              <div class="orm-row">
                <div class="orm-col-xs-12">
                  <a
                    class="orm-textlink"
                    v-if="hasDetails"
                    :href="
                      baseUrl +
                        env.VUE_APP_BASE_URL +
                        env.VUE_APP_STATIONS_PATH +
                        slugMe(station.name)
                    "
                    ><h1 class="orm-headline__h3 orm-mb-8">
                      {{ station.name }}
                    </h1></a
                  >
                  <h1 v-else class="orm-headline__h3 orm-mb-8">
                    {{ station.name }}
                  </h1>
                </div>
                <div class="orm-col-xs-12 orm-col-sm-6 orm-mb-16 orm-mb-sm-0">
                  <div v-if="station.street">{{ station.street }}</div>
                  <div v-if="station.zipcode">
                    {{ station.zipcode }} {{ station.city }}
                  </div>
                  <div v-if="station.phone" class="orm-mt-16">
                    <i class="fas fa-phone"></i> {{ station.phone }}
                  </div>
                  <div v-if="station.email">
                    <i class="fas fa-envelope"></i>
                    <a
                      class="orm-stations__mail"
                      :href="'mailto:' + station.email"
                      >{{ station.email }}</a
                    >
                  </div>
                  <div class="hide-mobile-only" v-if="hasDetails">
                    <a
                      :href="
                        baseUrl +
                          env.VUE_APP_BASE_URL +
                          env.VUE_APP_STATIONS_PATH +
                          slugMe(station.name)
                      "
                      class="orm-button__cta small orm-mt-24"
                    >
                      {{ i18n("general/linktostation") || "Zur Station" }}
                    </a>
                  </div>
                </div>
                <div
                  v-if="station.opentimes"
                  class="orm-col-xs-12 orm-col-sm-6"
                >
                  <div v-if="station.opentimes.length > 0">
                    <div
                      v-for="opentime in station.opentimes"
                      :key="opentime.day_of_week"
                      class="orm-row"
                    >
                      <div class="orm-col-xs-2">
                        {{
                          i18n(
                            "Wochentage_kurz/" + opentime.day_of_week,
                            true
                          ) || opentime.day_of_week
                        }}:
                      </div>
                      <div
                        v-if="opentime.times.length > 0"
                        class="orm-col-xs-8"
                      >
                        <div v-for="time in opentime.times" :key="time">
                          {{ time }} {{ i18n("general/hour") || "Uhr" }}
                        </div>
                      </div>
                      <div v-else class="orm-col-xs-8">
                        {{ i18n("general/closed") || "geschlossen" }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="orm-col-xs-12 show-mobile-only orm-mt-16"
                  v-if="hasDetails"
                >
                  <a
                    :href="
                      env.VUE_APP_BASE_URL +
                        env.VUE_APP_STATIONS_PATH +
                        slugMe(station.name)
                    "
                    class="orm-button__cta orm-btn__block text-center"
                  >
                    {{ i18n("general/linktostation") || "Zur Station" }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import store from "@/store";
import { slugMe } from "@/constants/formater";
import i18n from "@/mixins/mixins";
import { useRoute } from "vue-router";

export default {
  components: {},
  props: ["name"],
  mixins: [i18n],
  setup() {
    let widget = false;
    const myEle = document.getElementById("crentStationList");
    const stationsAll = store.getters["stations/GET_STATIONS_FILTERED"];
    let hasDetails = false;

    let sttype = "ALL";
    if (myEle !== null) {
      if (myEle.dataset) {
        if (myEle.dataset.detailpage) {
          hasDetails = myEle.dataset.detailpage === "true" ? true : false;
        }
      }
      sttype = document.getElementById("crentReservation").dataset.stationtype;
      widget = true;
    }
    const stations = stationsAll[sttype];
    const route = useRoute();
    const locale = route.params.locale ? "/" + route.params.locale : "";
    const baseUrl = window.location.origin + locale;

    // console.log("OPENTIMES______", stations);

    return {
      widget,
      stations,
      slugMe,
      hasDetails,
      baseUrl,
    };
  },
  data() {
    return {
      env: process.env,
    };
  },
};
</script>
